module.exports = __webpack_public_path__ + "static/media/book-who-is-nemos-detail4.eb81de01.jpg";